import { render, staticRenderFns } from "./FeGangedSelect.vue?vue&type=template&id=05ec8446&scoped=true&"
import script from "./FeGangedSelect.vue?vue&type=script&lang=js&"
export * from "./FeGangedSelect.vue?vue&type=script&lang=js&"
import style0 from "./FeGangedSelect.vue?vue&type=style&index=0&id=05ec8446&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ec8446",
  null
  
)

export default component.exports